import { useApi, apiResolver } from "@/api/useApi";
import { useMemo } from "react";
import {
  TenantBrand,
  UpsertBrandInputDto,
  CreateBrandResponse,
  GetBrandResponse,
  UpdateBrandResponse,
  DeleteBrandResponse,
  GetBrandsResponse,
} from "./Brand.model";

type GetBrandsRequest = {
  tenantId: string;
};

type GetBrandRequest = {
  tenantId: string;
  externalBrandId: string;
};

type CreateBrandRequest = {
  tenantId: string;
  data: UpsertBrandInputDto;
};

type UpdateBrandRequest = {
  externalBrandId: string;
  data: UpsertBrandInputDto;
};

type DeleteBrandRequest = {
  externalBrandId: string;
};

export function useBrandApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getBrands: () =>
        apiResolver<GetBrandsResponse>(api.get(`/platform/tenant-brand`)),
      getBrand: ({ externalBrandId }: GetBrandRequest) =>
        apiResolver<GetBrandResponse>(
          api.get(`/platform/tenant-brand/${externalBrandId}`)
        ),
      createBrand: (data: UpsertBrandInputDto) =>
        apiResolver<CreateBrandResponse>(
          api.post(`/platform/tenant-brand`, data)
        ),
      updateBrand: ({ externalBrandId, data }: UpdateBrandRequest) =>
        apiResolver<UpdateBrandResponse>(
          api.put(`/platform/tenant-brand/${externalBrandId}`, data)
        ),
      deleteBrand: ({ externalBrandId }: DeleteBrandRequest) =>
        apiResolver<DeleteBrandResponse>(
          api.delete(`/platform/tenant-brand/${externalBrandId}`)
        ),
    }),
    [api]
  );
}
